import Vue from 'vue'
import VuePortal from '@linusborg/vue-simple-portal/dist/index.esm'

Vue.use(VuePortal)
